import { useAppSelector } from "../redux/hooks";
import { useApplyCompanyTheme } from "../theme/applyCompanyTheme";

/**
 * Reads the company theme from Redux and applies it to the document root
 * as CSS custom properties.  Falls back to DEFAULT_THEME for any missing key.
 *
 * Call once in a layout component (e.g. Sidebar/RootLayout).
 * Every component that uses `--brand-*` variables or their Tailwind utilities
 * from @theme will automatically reflect the live theme.
 */
export function useTheme() {
  const rawTheme = useAppSelector((s) => s.company.theme);
  return useApplyCompanyTheme(rawTheme);
}
